<template>
    <div id="loan-status-dates">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h6 class="bold success">
                    PROYECTOS RELACIONADOS
                </h6>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-table :data="relatedProjects" max-items="2" pagination>
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td>
                                            <div color="primary" @click="handleSelected(tr)">{{ tr.id }} | {{ tr.alias}}</div>
                                        </vs-td>
                                        <vs-td>
                                            {{ projectStatusName(tr.status) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ explicitCreditStatus(tr.credit_status) }}<br>
                                            <label class="pill-danger" v-if="tr.restructured_loan">Reestructurado</label>
                                        </vs-td>
                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import projectStatusesHelper from "@mixins/projectStatusesHelper";
import creditStatusesHelper from "@mixins/creditStatusesHelper";

const columns = [
    { title: "PID", key: "pid", sortable: true },
    { title: "ESTADO", key: "status", sortable: true },
    { title: "ESTADO DEL CRÉDITO", key: "credit_status", sortable: true }
];

export default {
    name: "BankAccountsDetail",
    mixins: [projectStatusesHelper, creditStatusesHelper],
    data: () => ({
        columns: columns
    }),
    props: {
        source: Object,
        relatedProjects: Array
    },
    async mounted() {
        // await this.getProjectsRelated();
    },
    computed: {
        isMoral() {
            return this.source.client.user.person_type == 0;
        },
        user_applicant() {
            return this.source.client.user;
        },
        applicant() {
            return this.source.client;
        },
        bankAccounts(){
            if(this.isMoral) {
                return this.user_applicant.business.bank_accounts;
            } else {
                return this.user_applicant.personal.bank_accounts;
            }
        }
    },
    methods: {
        async handleSelected(proj) {
			window.open(`/risk-model/expediente/${proj.id}`, '_blank');
		},
    }
}
</script>

<style>
#loan-status-dates .vx-card__body {
    padding: .5rem !important;
}
</style>